<template>
  <div>
    <div class="shadow p-3 br8">
      <div class="d-flex align-items-center">
        <font-awesome-icon :icon="['fas', 'pen']" class="cp mr-1 ml-auto" :style="{ color: getPrimary300Color() }" @click="() => handleEdit()" />
        <font-awesome-icon :icon="['fas', 'trash']" class="cp ml-4 error300" @click="() => handleDelete()" />
      </div>
      <img
        v-if="displayData.img && displayData.img.length"
        :src="displayData.img[0].resized_images ? displayData.img[0].resized_images.dov1280x720 : displayData.img[0].url"
        alt="image"
        class="mt-3"
      />
      <p class="mb-0 gray900 fw700 font18 mt-3">
        {{ displayData.title }}
      </p>
      <div class="p1224 br8 bg-gray100 gray900 fw700 font16 mt-3" v-for="choice in displayData.choices" :key="choice.choice_text">
        {{ choice.choice_text }}
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "NewPollData",
  props: {
    displayData: Object,
    handleEdit: Function,
    handleDelete: Function,
  },
}
</script>

<style lang="scss" scoped>
img {
  max-width: 507px;
  max-height: 278px;
  background-size: contain;
  object-fit: contain;
  background: white;
}
</style>



// WEBPACK FOOTER //
// src/components/home/createNewPost/data/Poll.vue